import styled from 'styled-components';
export const Container = styled.div`
  width: 100%;
  height: 100%; 
  .tabs--{
    background-color:#f6f6f6;
    padding: 0 0.5rem 0 0.5rem;
  }
  .adminTabLoading{
    color: transparent;
    pointer-events: none;
    background-color:#e9ecef;
    background-image: linear-gradient(to right, #e9ecef 0%, rgba(0,0,0,0.05) 20%, #e9ecef 40%, #e9ecef 100%);
    background-repeat: no-repeat;
    background-size: 450px 400px;
    animation: shimmer 2s linear infinite;
    @keyframes shimmer {
      0%{
        background-position: -450px 0;
      }
      100%{
        background-position: 450px 0;
      }
    }
  }
  .selected{
    background-color: #1D86FF;
    color:#ffff ;
  }
`
export const Content = styled.div`
  position: relative;
  width: 100%;
  height: calc(100% - 3.5rem);
`
export const Notification = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 0.5rem;

  span{
    display: flex;
    min-width: 1.3rem;
    min-height: 1.3rem;
    justify-content: center;
    align-items: center;
    font-size: 0.7rem;
    font-weight: 600;
  }
  .white{
    color: #000;
    background-color: #fff;
    border: 1px solid #dee2e6;
    border-radius: 50%;
  }

  .green{  
    color:#fff;
    background-color: #03d755;
    border: 1px solid #03d755;
    border-radius: 50%;
  }

  .bigger{
    border-radius: 50px;
    padding: 0 0.35rem;
  }

`